import React,{ Component } from 'react';
import $ from 'jquery';
import { Link } from 'react-router';
import { ButtonToolbar,DropdownButton, MenuItem, Panel } from 'react-bootstrap';
import { ShareButtons, generateShareIcon } from 'react-share';

const {FacebookShareButton,GooglePlusShareButton,TwitterShareButton} = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');

const baseAssets='https://aquadeals.in/admin/assets/';

export default class SeedsCat extends Component {

	constructor(props){
		super(props);
		this.state={
			seedsList: [],
			offer: {},
			sort_status: true,
			sort: '1',
			img_price: 'price.png',
			coasts: [],
			coast:'0',
			nodata: false,
			img_data: 'Price',
			open: false,
			latitude: '',
			longitude: '',
			seed_type: this.props.params.Stype,
			shareUrl: '',
			loading: false,
			web_title: '',
			web_desc: '',
			seo_title:'',
			seo_desc:'',
			cart_count:0,
		};
		this.showPosition=this.showPosition.bind(this);
		this.showError = this.showError.bind(this);
		this.getNearBy=this.getNearBy.bind(this);
		this.getSort=this.getSort.bind(this);
		this.getCoasts=this.getCoasts.bind(this);
		this.getSelectedCoast=this.getSelectedCoast.bind(this);
		this.getDeviceId=this.getDeviceId.bind(this);
		this.getCartCount=this.getCartCount.bind(this);
	}
	getCartCount()
 	{
	    var baseUrl='https://aquadeals.in/admin/web3/user/';
	    var data1={from: 'mobile_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token')};
	    var data2=JSON.stringify(data1);
	    $.ajax({
	          method: 'POST',
	          url: baseUrl+'cart_count',
	          dataType:'json',
	          data: {req:data2},
	          success: function(data)
	          {
	            this.setState({
	                cart_count:data.cart_count,
	            });
	          }.bind(this),
	          error: function(err)
	          {
	          
	          }
	    });
 	}
	showPosition(position) 
	{
		this.setState({
	    	latitude: position.coords.latitude,
	    	longitude: position.coords.longitude,
	    })
	}
	getDeviceId()
	{
	    if(localStorage.user_id){
	        var user_id=localStorage.user_id;
	    }
	    else{
	      user_id=0;
	    }
	    var data1={from: 'mobile_web',id: user_id, device_id: localStorage.getItem('push_device_id')}
	    var data2=JSON.stringify(data1);
	    var baseUrl='https://aquadeals.in/admin/web3/user/';
	    $.ajax({
	        method: 'POST',
	        url: baseUrl+'getDeviceId',
	        dataType: 'json',
	        data:{req: data2},
	        success: function(data){
	          
	        },
	        error: function(err){
	        }
	    });
  }
	showError(error)
	{
	    switch(error.code)
	    {
	        case error.PERMISSION_DENIED:
	            // console.log("User denied the request for Geolocation.");
	            break;
	        case error.POSITION_UNAVAILABLE:
	            // console.log("Location information is unavailable.");
	            break;
	        case error.TIMEOUT:
	            // console.log("The request to get user location timed out.");
	            break;
	        case error.UNKNOWN_ERROR:
	            // console.log("An unknown error occurred.");
	            break;
	        default: 
	        console.log('');
	        break;
	    }
	}

	getNearBy()
	{
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from: 'mobile_web',lat:this.state.latitude, long:this.state.longitude,coast:this.state.coast,sort:this.state.sort,species:this.state.seed_type};
		var data2=JSON.stringify(data1);
		$.ajax({
			method: 'POST',
			url: baseUrl+'getdeals',
			dataType: 'json',
			data:{req: data2},
			success: function(data)
			{
				if(data.data.length === 0){
					this.setState({
						nodata: true,
					});
				}
				else{
					this.setState({
						nodata: false,
						seedsList:data.data,
						offer: data,
					});
				}
			}.bind(this),
			error: function(err)
			{
			}
		});
	}
	getCoasts()
	{
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from: 'mobile_web'};
		var data2=JSON.stringify(data1);
		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'coasts',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data)
      		{
        		this.setState({
	       			coasts:data.coasts,
	       		});
  			}.bind(this),
  			error: function(err)
  			{
  			}
        });
	}		

	componentDidMount()
	{
		if(screen.width >= 800){
			window.location.href="/web/seed/"+this.props.params.Name+"/"+this.props.params.Stype;
		}
		
		if(navigator.geolocation){
			navigator.geolocation.getCurrentPosition(this.showPosition,this.showError);
		}
		else{
			alert("GeoLocation is not supported by the browser");
		}
		if(localStorage.user_id && localStorage.token)
		{
			this.getCartCount();
		}
		this.getDeviceId();
		this.getCoasts();
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from: 'mobile_web',species: this.state.seed_type};
		var data2=JSON.stringify(data1);

		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'getdeals',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data){
        		this.setState({
	       			seedsList:data.data,
	       			offer: data,
	       			loading: true,
	       			web_title: data.title,
	       			seo_title:data.title+' Aqua seed deals from Hatcheries',
	       			seo_desc:'Browse quality '+data.title+' seed deals from CAA approved Hatcheries, shop online and avail free shipment.',
	       			web_desc: data.desc,
	       		});
	       	document.title =this.state.web_title+ "";
            document.getElementsByTagName("META")[2].content=this.state.seo_desc;
  			}.bind(this),
  			error: function(err){
  			}
        })
	}			
	getSort()
	{
		localStorage.setItem('sort',this.state.sort);
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from: 'mobile_web',sort:this.state.sort,species: this.state.seed_type,coast:this.state.coast};
		var data2=JSON.stringify(data1);
		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'getdeals',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data){
        		if(this.state.sort === 1)
	    		{
	    			var ss = 2;
	    			var img_price = 'down.png';
	    			var img_data = 'High - Low';
	    		}
	    		else
	    		{
	    			ss = 1;
	    			img_price = 'up.png';
	    			img_data ='Low - High';
	    		}
	    		this.setState({
					sort: ss,
					img_price: img_price,
					img_data: img_data,
				});
	    		this.setState({
	       			seedsList:data.data,
	       			offer: data,
	       			web_title: data.title,
	       			web_desc: data.desc,
	       		});
	       	// document.title =this.state.web_title+ "- Seed | AquaDeals | "+this.state.seo_desc;
	       	document.title =this.state.web_title+ "- Seed | AquaDeals";
	       	document.getElementsByTagName("META")[2].content=this.state.seo_desc;
  			}.bind(this),
  			error: function(err){
  				
  			}
        });
	}
	getSelectedCoast(c)
	{
		this.setState({
			coast:c,
		});
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from: 'mobile_web',coast: c,species: this.state.seed_type,sort:localStorage.sort};
		var data2=JSON.stringify(data1);
		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'getdeals',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data){
        		if(data.data.length === 0){
        			this.setState({
        				nodata: true,
        			})
        		}
        		else{
        			this.setState({
        				nodata: false
        			})
        		}
        		this.setState({
	       			seedsList:data.data,
	       			offer: data,
	       			web_title: data.title,
	       			web_desc: data.desc,
	       		});
        		document.title =this.state.web_title+ "- Seed | AquaDeals ";
            	document.getElementsByTagName("META")[2].content=this.state.seo_desc;
  			}.bind(this),
  			error: function(err){
  			}
        });
	}
	render()
	{
	var products = this.state.seedsList.map((product, index) => (<Product key={product.deals_data.id} data={product} />));
	var getTitle = this.state.seed_type === '1' ? 'Vannamei' : 'Tiger';
	return(
	<div className="mob_deals seed_list_cat_page">
		<div className="page_hdr">
			<div className="container-fluid">
				<h5><Link to="/"><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></Link>{getTitle}</h5>
				<a href="/" className="home_logo1"><img src={'https://aquadeals.in/admin/assets/images/web_imgs/home1.png'} alt="Home" /></a>
				<a className="mob_cart_btn" href="/mycart">
					<img alt="" src={'https://aquadeals.in/admin/assets/icons/web_icons/cart_icon.png'} />
					{this.state.cart_count > 0 ? <span className={this.state.cart_count > 9 ? "mob_cart_count1" : "mob_cart_count"}>{this.state.cart_count}</span> : ''}
				</a>
			</div>
		</div>
		
		<div className="pag_cntnt">&nbsp;</div>
			<section className="container-fluid">
				{this.state.nodata ? <div className="no_data">
					<h3>No Deals Available</h3>
					<p>Need something here? <Link to="/customer_care">CONTACT US</Link> now !</p>
				</div> : products.length >0 ? products : <div className="no_data">
					<h3>No Deals Available</h3>
					<p>Need something here? <Link to="/customer_care">CONTACT US</Link> now !</p>
				</div> }			
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
		</section>
		<section className="seed_sort">
			<ul>
				<li className="col-md-4 col-xs-4 col-sm-4">
					<a onClick={this.getSort} title=""><img src={'https://aquadeals.in/admin/assets/images/web_imgs/'+this.state.img_price} alt="sort" /><span>{this.state.img_data}</span></a>
				</li>
				<li className="col-md-4 col-xs-4 col-sm-4 coast_list ">
					<ButtonToolbar>
						<DropdownButton className="test_filter" noCaret title="Coasts" dropup>
							{this.state.coasts.map((coast,index) => (<MenuItem eventKey={coast.id} onClick={()=>this.getSelectedCoast(coast.id)}>{coast.coast}</MenuItem>))} 
						</DropdownButton>
	      			</ButtonToolbar>
      			</li>
				<li className="col-md-4 col-xs-4 col-sm-4">
					<a onClick={this.getNearBy} title=""><img src={'https://aquadeals.in/admin/assets/images/web_imgs/nearby.png'} alt="nearby" /> <span>Nearby</span> </a>
				</li>
			</ul>
		</section>
	</div>
	);
	}
}

export class Product extends Component{
	constructor(){
		super();
		this.state={
			open: false,
		}
		this.ShareFunc=this.ShareFunc.bind(this);
	}
	ShareFunc(evnt){
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from: 'mobile_web',type:0,did:evnt};
		var data2=JSON.stringify(data1);
		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'createTinyurl',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data)
      		{
        		this.setState({
        			msg: data.msg,
        			shareUrl: data.tinyurl,
        		})
        	}.bind(this),
  			error: function(err){
  			}
        });
		this.setState({ open: !this.state.open });
	}
	render(){
		var mydata=this.props.data;
		var shareUrl = this.state.shareUrl;
		var title = "Hey Click here "+ shareUrl+ " to check " + mydata.deals_data.sname + " from AquaDeals.";
		var description= shareUrl;
		return(
		<div className="list_card">
			<Link to={"/sdetails/"+mydata.deals_data.sname+"/"+mydata.deals_data.id}>
				<div className="list_img">
					<img src={'https://aquadeals.in/admin/assets/images/seller_imgs/thumbnails/'+mydata.deals_data.image} alt="AquaDeals" role="presentation" />
				</div>
				<div className="list_txt">
					{mydata.deals_data.sname ? <h4 style={{color:'#111'}}>{mydata.deals_data.sname}</h4> : ''}
					{mydata.deals_data.discount_price > 0 ? <h5>&#8377; {mydata.offer} off on 1M</h5> : ''}
				{/* {mydata.deals_data.discount_price > 0 ? <p><span className="offer_old">&#8377;{mydata.deals_data.price}</span><span className="offer_new">&#8377;{mydata.deals_data.discount_price}</span></p> : <p><span className="offer_new_single">&#8377;{mydata.deals_data.price}</span></p>  } */}
					{mydata.deals_data.price ? <p><span></span><span style={{color:'#111'}}>&#8377;</span><span style={{color:'#111'}}>{mydata.deals_data.price}</span></p> : ''}
					{mydata.deals_data.rate >=1  ? <h6><i><img src={'https://aquadeals.in/admin/assets/images/web_imgs/star_filled.png'} width="16px" role="presentation"/></i> {mydata.deals_data.rate} </h6> : <h6><i><img src={'https://aquadeals.in/admin/assets/images/web_imgs/star_gray.png'} width="16px" role="presentation"/></i></h6> }  
				</div>
			</Link>
			<Link className="share_list" onClick={()=>{this.ShareFunc(mydata.deals_data.id)}}><img src={'https://aquadeals.in/admin/assets/images/web_imgs/share1.png'} alt="share" /></Link>
				{mydata.view_status >0 ? <h6 className="views_eye"><img src={'https://aquadeals.in/admin/assets/images/web_imgs/eye.png'} width="17px" role="presentation"/> {mydata.view_status} {mydata.view_status >1 ? 'Views' : 'View'}</h6> : ''}
				<div>
					<Panel className="share_panel" collapsible expanded={this.state.open}>
					    <FacebookShareButton url={shareUrl} quote={title} description={description} className="test_share">
							<FacebookIcon size={32} round />
						</FacebookShareButton>
						<TwitterShareButton url={shareUrl} quote={title} description={description} className="test_share">
							<TwitterIcon size={32} round />
						</TwitterShareButton>
						<GooglePlusShareButton url={shareUrl} quote={title} description={description} className="test_share">
							<GooglePlusIcon size={32} round />
						</GooglePlusShareButton>
			        </Panel>
				</div>
		</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/components/Categories/Seed/SeedsCat.js
 **/